/**
 *
 * Asynchronously loads the component for Ben009
 * Author: Locnt
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
